import {Field} from './crud/Field';
import {ModalFields} from './modal-fields';
import {Config} from './crud/Config';
import {TimeTrackerService} from '../app/time-tracker-service.service';

export class Team {
    public id: string;
    public name: string;
    public logoPath: string;
    public active: boolean;

    // No Model Field
    public selected: boolean;
    constructor() {
    }

    /**
     * @param {string} companyId required
     * * @param {Team} team @Nullable or initial data
     * @returns {ModalFields}
     */
    public static toModelTemplate(companyId: string, team: Team) {
        console.log('convert team: ', team);
        const path = TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.TEAMS;
        const idField = new Field('id', 'id', 'text', false);
        const nameField = new Field('MODEL.TEAM.NAME', 'name', 'text', true);
        const logoField = new Field('MODEL.TEAM.LOGO', 'logoPath', 'image', false);
        const activeField = new Field('MODEL.TEAM.ACTIVE', 'active', 'checkbox', false);

        idField.hidden = true;

        if (team != null) {
            idField.value = team.id;
            nameField.value = team.name;
            logoField.value = team.logoPath;
            activeField.value = team.active;
        }
        const modalFields = new ModalFields(
            [idField, nameField, logoField, activeField],
            new Config(''),
            false, false, false
        );
        modalFields.firebaePath = path;
        return modalFields;
    }
}



// WEBPACK FOOTER //
// ./src/models/team.ts